import { render, staticRenderFns } from "../modules/Case2.0/template/case-list.html?vue&type=template&id=451db5b4&scoped=true&"
import script from "../modules/Case2.0/script/Case2-list.ts?vue&type=script&lang=js&"
export * from "../modules/Case2.0/script/Case2-list.ts?vue&type=script&lang=js&"
import style0 from "../modules/Case2.0/style/cases-list.scss?vue&type=style&index=0&id=451db5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451db5b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
